import { Translate } from 'next-translate';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { MenuItem } from '@components/layout/SideMenu/types';

const helpMenuItem = (id: string, url: string, text: string, visible: boolean): MenuItem => {
  return {
    icon: <QuestionCircleOutlined />,
    id,
    path: url,
    rel: 'noopener noreferrer',
    target: '_blank',
    text,
    visible,
  };
};

export const getHelpMenuItemData = (t: Translate, isBuyer: boolean, isSupplier: boolean, isSuperAdmin: boolean, isImpersonating: boolean): MenuItem[] => {
  const supplierHelpUrl = process.env.NEXT_PUBLIC_HELP_PAGE_SUPPLIER_URL;
  const buyerHelpUrl = process.env.NEXT_PUBLIC_HELP_PAGE_BUYER_URL;
  const supplierHelpText = t('general.help_supplier');
  const buyerHelpText = t('general.help_buyer');
  const showBuyerHelp = isBuyer || (isSuperAdmin && !isImpersonating);
  const showSupplierHelp = isSupplier || (isSuperAdmin && !isImpersonating);

  return [
    helpMenuItem('help-buyer-item', buyerHelpUrl as string, buyerHelpText, showBuyerHelp),
    helpMenuItem('help-supplier-item', supplierHelpUrl as string, supplierHelpText, showSupplierHelp)
  ];
};
